import {Pagination , PaginationItem } from '@mui/material'
import { useEffect } from 'react';
import { useDispatch , useSelector} from 'react-redux';
import { Link } from 'react-router-dom';
import {getPosts} from '../../actions/posts'; 

const Paginate = ({page}) => {
 
  const numberOfPages  = useSelector((state) => state.postsReducer.numberOfPages) ;  //getting pages count from the Reducer
  const dispatch = useDispatch();          //getting the dispatch hook
  // using dispatch hook to dispatch getposts action by page number when the page changes
  useEffect(() => {
     if (page) { dispatch(getPosts(page)); }
  }, [dispatch,page]);  
  
  return (
    <Pagination color="primary" variant="outlined" count={numberOfPages} page={Number(page) || 1} 
               renderItem={(item) => (<Link to={`/posts?page=${item.page}`}> <PaginationItem  {...item} /> </Link>)}
      />
  )
}

export default Paginate ;